import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { RolesService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class RoleListBloc extends Bloc<RolesService['roleControllerGet']> {
    public constructor(service: RolesService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.roleControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
